import BaseScene from './BaseScene'
import MsdfText from '../objects/MsdfText'
import DomImage from '../objects/DomImage'
import Device from '../objects/Device'
import Claw from '../objects/Claw'
import SceneAudio from '../objects/SceneAudio'
import Wires from '../objects/Wires'
import XrayMode from '../objects/XrayMode'

export default class MainScene extends BaseScene {
	static defaults = {
		textSelector: '[data-three-text]',
		imageSelector: '[data-3d-image]',
		deviceSelector: '[data-three-device]',
		clawSelector: '[data-three-claw]',
		clawContainerSelector: '[data-claw-container]',
	}

	addObjects() {
		const { textSelector, imageSelector, deviceSelector, clawSelector, clawContainerSelector } = this.options
		const camera = this.camera

		this.audio = this.addObject(new SceneAudio(camera))
		this.texts = []

		const device = document.querySelector(deviceSelector)

		if (device) {
			const object = this.addObject(
				new Device({
					element: device,
					camera,
					renderer: this.renderer,
					project: this.project,
					listener: this.audio.listener,
				})
			)

			object.init()
			this.addObject(new Wires({ device: object }))
			this.xray = this.addObject(new XrayMode({ device: object, scene: this, texts: this.texts }))
		}

		const section = document.querySelector(clawSelector)
		const container = section?.querySelector(clawContainerSelector)

		if (container) {
			this.addObject(
				new Claw({
					element: container,
					section,
					camera,
					renderer: this.renderer,
				})
			).init()
		}

		for (const element of document.querySelectorAll(textSelector)) {
			MsdfText.fromElement(element, { camera }).then(text => this.texts.push(this.addObject(text)))
		}

		for (const element of document.querySelectorAll(imageSelector)) {
			this.addObject(new DomImage({ element, camera }))
		}
	}
}
